import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { PaymentMethodsService } from 'src/pages/admin/settings/admin-setting-payments/payment-methods/payment-methods.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { loadPaymentMethods, loadPaymentMethodsFailure, loadPaymentMethodsSuccess } from './payment-methods.actions'

@Injectable()
export class PaymentMethodEffects {
  private actions$ = inject(Actions)
  private PaymentMethods = inject(PaymentMethodsService)
  private toaster = inject(ToasterService)


  loadPaymentMethods$ = createEffect(() => this.actions$.pipe(
    ofType(loadPaymentMethods),
    switchMap(() =>
      from(this.PaymentMethods.getPaymentMethods()).pipe(
        map(paymentMethods => loadPaymentMethodsSuccess({ paymentMethods })),
        catchAndLog(this.toaster, 'Unable to fetch paymentMethods', loadPaymentMethodsFailure
      )))))
}
